import { gql } from '@apollo/client'

export const GravityFormsFragment = gql`
  fragment GravityFormsFragment on GfForm {
    id
    databaseId
    title
    submitButton {
      text
      type
    }
    formFields(first: 100) {
      nodes {
        ... on TextAreaField {
          databaseId
          placeholder
          pageNumber
          value
          type
          label
          isRequired
          labelPlacement
        }
        ... on FileUploadField {
          id
          databaseId
          label
          type
        }
        ... on NameField {
          databaseId
          pageNumber
          type
          value
          label
          isRequired
          labelPlacement
        }
        ... on AddressField {
          type
          pageNumber
          label
          description
          cssClass
          isRequired
          inputs {
            id
            label
            ... on AddressInputProperty {
              id
              name
              key
            }
          }
        }
        ... on CaptchaField {
          databaseId
          pageNumber
          captchaLanguage
          captchaTheme
          captchaType
          cssClass
          description
          descriptionPlacement
          errorMessage
          label
          simpleCaptchaBackgroundColor
          simpleCaptchaFontColor
          simpleCaptchaSize
          type
        }
        ... on ListField {
          databaseId
          type
          pageNumber
          label
          description
          isRequired
          isRequired
          labelPlacement
          listValues {
            values
          }
        }
        ... on SelectField {
          databaseId
          type
          pageNumber
          label
          description
          cssClass
          isRequired
          labelPlacement
          defaultValue
          placeholder
          choices {
            text
            value
          }
        }
        ... on TextField {
          databaseId
          pageNumber
          isRequired
          placeholder
          labelPlacement
          type
          value
          label
        }
        ... on NumberField {
          databaseId
          pageNumber
          isRequired
          placeholder
          labelPlacement
          type
          value
          label
        }
        ... on PhoneField {
          databaseId
          pageNumber
          isRequired
          placeholder
          labelPlacement
          type
          value
          label
        }
        ... on EmailField {
          databaseId
          pageNumber
          isRequired
          placeholder
          labelPlacement
          type
          value
          label
        }
        ... on AddressField {
          databaseId
          pageNumber
          isRequired
          type
          value
          label
        }
        ... on NameField {
          id
          pageNumber
          isRequired
          type
          value
          label
          inputs {
            label
            id
            ... on NameInputProperty {
              id
              name
              isHidden
              key
            }
          }
          nameValues {
            first
            last
          }
        }
        ... on CheckboxField {
          databaseId
          isRequired
          labelPlacement
          id
          label
          pageNumber
          type
          value
          inputs {
            label
            id
            name
          }
        }
      }
    }
  }
`

export const MUTATE_DATA = gql`
  mutation MUTATE_DATA($fieldValues: [FormFieldValuesInput]!, $databaseId: ID!) {
    submitGfForm(input: { id: $databaseId, fieldValues: $fieldValues }) {
      confirmation {
        type
        message
        url
      }
    }
  }
`
